import SingleRow from './SingleRow';

export default SingleRow;